import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AnessaTranslationService } from '../../../../helper/translation/anessa-translation.service';
import { UserpilotReloader } from '../../../../helper/userpilot-reloader.component';

@Component({
  selector: 'app-checklist-template-name--dialog',
  templateUrl: './checklist-template-name-dialog.component.html',
  styleUrls: [
    './checklist-template-name-dialog.component.scss',
  ]
})
export class ChecklistTemplateNameDialogComponent extends UserpilotReloader{
  name: string;
  forbiddenNames: string[];
  error = false;
  errorMessage = '';

  constructor(
    private dialogRef: MatDialogRef<ChecklistTemplateNameDialogComponent>,
    private translationService: AnessaTranslationService,
    @Inject(MAT_DIALOG_DATA) private data: { name: string, forbiddenNames: string[] },
  ) {
    super();
    if (this.data) {
      this.name = data.name || '';
      this.forbiddenNames = data.forbiddenNames || [];
    }
  }

  onInput() {
    if (this.name === '') {
      this.error = true;
      this.errorMessage = 'name cannot be empty';
    } else if (this.forbiddenNames !== undefined && this.forbiddenNames.includes(this.name)) {
      this.error = true;
      this.errorMessage = 'duplicate name';
    } else {
      this.error = false;
      this.errorMessage = '';
    }
  }

  onSend() {
    this.onInput();
    if (!this.error) this.dialogRef.close(this.name);
  }
}
